import React, { useEffect, useState } from 'react';
import { FaArrowRight, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import './Hero.css';

function Hero() {
  const slides = [
    {
      image: '/images/Fredsonimg 2.jpg',
      eyebrow: 'Built for what is next',
      title: 'Engineering that moves Nigeria forward.',
      subtitle: 'Integrated technology for construction, mining, and rock drilling projects that demand precision.'
    },
    {
      image: '/images/Fredsonimg 5.jpg',
      eyebrow: 'Precision underground',
      title: 'Powerful solutions. Grounded in expertise.',
      subtitle: 'From geological insight to controlled execution, our teams turn difficult ground into dependable progress.'
    },
    {
      image: '/images/Fredsonimg 6.jpg',
      eyebrow: 'Ready for the challenge',
      title: 'Safer work. Smarter outcomes.',
      subtitle: 'Technology, safety, and sustainability working together across every stage of your project.'
    }
  ];
  const [activeSlide, setActiveSlide] = useState(0);

  useEffect(() => {
    const slideTimer = setInterval(() => {
      setActiveSlide(currentSlide => (currentSlide + 1) % slides.length);
    }, 6500);

    return () => clearInterval(slideTimer);
  }, [slides.length]);

  const moveSlide = direction => {
    setActiveSlide(currentSlide => (currentSlide + direction + slides.length) % slides.length);
  };

  const slide = slides[activeSlide];

  return (
    <section className="hero" aria-label="C.U Fredson highlights">
      <div className="hero-image" key={slide.image}>
        <img src={slide.image} alt="Engineering project site" />
      </div>
      <div className="hero-overlay"></div>
      <div className="hero-grid"></div>

      <div className="hero-content" key={slide.title}>
        <p className="hero-eyebrow">{slide.eyebrow}</p>
        <h1 className="hero-title">{slide.title}</h1>
        <p className="hero-subtitle">{slide.subtitle}</p>
        <div className="hero-buttons">
          <Link to="/services" className="btn btn-primary">Explore services <FaArrowRight /></Link>
          <a href="https://wa.me/+2348034648000" className="btn btn-secondary" target="_blank" rel="noopener noreferrer">Start a conversation</a>
        </div>
      </div>

      <div className="hero-controls">
        <button type="button" onClick={() => moveSlide(-1)} aria-label="Previous slide"><FaChevronLeft /></button>
        <div className="hero-dots" aria-label="Choose a slide">
          {slides.map((item, index) => (
            <button
              type="button"
              key={item.title}
              className={index === activeSlide ? 'active' : ''}
              onClick={() => setActiveSlide(index)}
              aria-label={`Show slide ${index + 1}`}
              aria-pressed={index === activeSlide}
            />
          ))}
        </div>
        <button type="button" onClick={() => moveSlide(1)} aria-label="Next slide"><FaChevronRight /></button>
      </div>

      <span className="hero-slide-count">0{activeSlide + 1} <i>/</i> 0{slides.length}</span>
    </section>
  );
}

export default Hero;
